module.exports = __webpack_public_path__ + "static/media/links-icon.8e5eb633.png";